import { useState,useEffect } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../../utils/data/essential";
import { useFetchData } from "../../hooks/useFetchData";
import { reconciliationActionColumns } from "../../utils/columns/reconciliationDetailsColumns";
import { Link, useParams } from "react-router-dom";
import { Button } from "react-bootstrap";
import CreateReconciliationAction from "../../Component/reconciliation/CreateReconciliationAction";
import ReconDetails from "../../Component/reconciliation/ReconDetails";
const ReconciliationAction = () => {
  const [show, setShow] = useState(false);
  const [results, setResults] = useState()
  const [reconStatus, setReconStatus] = useState(null)
  const { period } = useParams();
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("user"));
  const url = `operators/reconciliations/${id}/actions`;
  const { data } = useFetchData(["reconciliation-details"], url,true,user);
  useEffect(() => {
    if (data) {
      const result = data?.reverse()
      setResults(result);
    }
  },[data])
  const handleCloseModal = () => setShow(false);
  const getDataFromChildComponent = (data) => setReconStatus(data)
  return (
    <>
      <div className='mt-2'>
        <ReconDetails
          reconPeriod={period}
          sendDataToParent={getDataFromChildComponent}
        />
      </div>
      <div className='d-flex justify-content-center mt-3'>
        <h3>Reconciliation Actions</h3>
      </div>
      <div className='d-flex justify-content-end mr-2'>
        <Link to='/loggedin/reconciliation'>
          <Button className='custom-btn-color mr-2'>
            <i className='fa fa-arrow-left mr-2' />
            Reconciliation
          </Button>
        </Link>
        {reconStatus?.id !== 4 && (
          <Button className='custom-btn-color' onClick={() => setShow(true)}>
            New Action
          </Button>
        )}
      </div>
      <div
        className='table-responsive datatables dataValidation-Wrap'
        style={{ width: "100%" }}
      >
        <DataTable
          columns={reconciliationActionColumns}
          data={results}
          responsive={true}
          customStyles={customStyles}
          highlightOnHover
          numberiped
          noHeader
        />
      </div>
      <CreateReconciliationAction
        show={show}
        hide={handleCloseModal}
        operatorId={100001}
        reconciliationId={id}
      />
    </>
  );
};

export default ReconciliationAction;
